<app-filtre-gestion
    #filtre
    [type]="type"
    [typeGestion]="typeGestion"
    [data]="data"
    (sendIdNationalChangeEvent)="receiveIdNationalChange($event)"
    (filtreGestionEvent)="receiveFiltreEvent($event)"
    (effacerFiltreEvent)="receiveEffacerFiltreEvent($event)">
</app-filtre-gestion>
